export const menu = {
	name: 'pNvsklad',
	list: [
		{ name: 'NV_PohybDokl', route: 'ArchyvPohybuDokladu' },
		{ name: 'NV_NaCeste', route: 'VozyNaCeste' },
		{ name: 'pNvsklad', route: 'SkladNovychVozu' },
	],
};
